import { Progress } from 'antd'
import React, { useEffect, useState } from 'react'

const STEP_MS = 500
const HIDE_DELAY_MS = 500
const MAX_PERCENT = 95

const WRAPPER_STYLE: React.CSSProperties = {position: 'absolute', top: 0, left: 0, width: '100%'}

// .ant-progress по умолчанию inline-block: он встаёт на текстовый baseline
// обёртки и отлипает от её верхней границы. Раньше flex приезжал вместе
// с `display: show ? 'flex' : 'none'`, который убрали вместе со скрытием.
const PROGRESS_STYLE: React.CSSProperties = {display: 'flex'}

const ProgressLoading = ({loading}: { loading: boolean }) => {
  const [ percent, setPercent ] = useState(5)
  const [ show, setShow ] = useState(false)

  // Раньше этот интервал крутился всегда, даже когда полоса скрыта, и дёргал
  // рендер каждые 500 мс на протяжении всей жизни страницы.
  useEffect(() => {
    if (!loading) return

    setPercent(5)
    const interval = setInterval(() => setPercent(v => (v < MAX_PERCENT ? v + 5 : MAX_PERCENT)), STEP_MS)

    return () => clearInterval(interval)
  }, [ loading ])

  // setTimeout не очищался: при быстрой смене loading полоса могла скрыться
  // уже после начала следующей загрузки.
  useEffect(() => {
    if (loading) {
      setShow(true)
      return
    }

    const timeout = setTimeout(() => setShow(false), HIDE_DELAY_MS)
    return () => clearTimeout(timeout)
  }, [ loading ])

  if (!show) return null

  return (
    <div style={ WRAPPER_STYLE }>
      <Progress
        percent={ loading ? percent : 100 }
        showInfo={ false }
        strokeLinecap="butt"
        size="small"
        style={ PROGRESS_STYLE }
      />
    </div>
  )
}

export default ProgressLoading
